export default "__VITE_PUBLIC_ASSET__578e7900__"